import { TabbedInterface } from "../../../components/layout/tabbed-interface/TabbedInterface";
import { useTranslation } from "../../../hooks/useTranslation";
import { CompetitionExceptionList } from "./tabs/CompetitionExceptionList/CompetitionExceptionList";
import { CompetitionOptions } from "./tabs/CompetitionOptions/CompetitionOptions";

const tabs = [
  {
    label: "competitionExceptionList",
    path: "exception-list",
    component: <CompetitionExceptionList />,
  },
  {
    label: "competitionOptions",
    path: "competition-options",
    component: <CompetitionOptions />,
  },
];

export const CompetitionSettings = () => {
  const { translate } = useTranslation("pages.stores.competitionSettings.tabs");

  return (
    <TabbedInterface tabs={tabs} defaultPath="general" translate={translate} />
  );
};
